module.exports = __webpack_public_path__ + "img/assuraf_sm.50a16c61.png";